module.exports = __webpack_public_path__ + "static/img/logo_black2.a2fd611.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_black2.png
// module id = kGAa
// module chunks = 24